const noop = Function.prototype;

let haWrapper = {
    userTiming: {
        mark: noop,
        measure: noop,
        measureAndSend: noop,
        clearMarks: noop,
        clearMeasures: noop,
        markAndMeasureAndSend: noop,
        getEntriesByName: noop
    }
};
// we only want to run this client-side
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.ha) {
    haWrapper = window.ha;
}

export default haWrapper;
